import React from 'react';
import { EditGenericEventModalContextProvider } from './context/EditGenericEventModalContext';
import EditGenericEventModal from './nested/modal';
import './styles.scss';
function EditGenericEventModalWrapper(params) {
    return (React.createElement(EditGenericEventModalContextProvider, { id: params.id, onClose: params.onClose, onSave: params.onSave, onDelete: params.onDelete },
        React.createElement(EditGenericEventModal, null)));
}
export default EditGenericEventModalWrapper;
